import { render, staticRenderFns } from "./qyzpxxDetail.vue?vue&type=template&id=2877e916&scoped=true"
import script from "./qyzpxxDetail.vue?vue&type=script&lang=js"
export * from "./qyzpxxDetail.vue?vue&type=script&lang=js"
import style0 from "./qyzpxxDetail.vue?vue&type=style&index=0&id=2877e916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2877e916",
  null
  
)

export default component.exports